import { render, staticRenderFns } from "./bannerHelp.vue?vue&type=template&id=874a27f4&"
import script from "./bannerHelp.vue?vue&type=script&lang=js&"
export * from "./bannerHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports